import { LoanSecurityTypeEnum } from '@talos/kyoko';

export const UNSECURED_LOAN_COLLATERAL_DISPLAY = 'Unsecured';

export function isUnsecuredLoanSecurityType(loanSecurityType: LoanSecurityTypeEnum | undefined | null): boolean {
  return loanSecurityType === LoanSecurityTypeEnum.Unsecured;
}

export function formatLoanSecurityTypeDisplay(
  loanSecurityType: LoanSecurityTypeEnum | undefined | null
): 'Secured' | 'Unsecured' {
  return isUnsecuredLoanSecurityType(loanSecurityType) ? 'Unsecured' : 'Secured';
}

/**
 * Collateral slot in the local instrument name: UNSEC for unsecured loans, otherwise the collateral asset.
 * Matches backend DisplaySymbol: LOAN-{borrowed}-UNSEC-{term}-FIXED[-BULLET].
 */
export function resolveLoanInstrumentCollateralSegment(
  loanSecurityType: LoanSecurityTypeEnum | undefined | null,
  collateralAsset: string | null | undefined
): string | undefined {
  if (isUnsecuredLoanSecurityType(loanSecurityType)) {
    return 'UNSEC';
  }
  return collateralAsset || undefined;
}

/**
 * Display value for the compact Collateral Asset slot (blotter) and unsecured tooltip value.
 * Unsecured loans always show "Unsecured", even when legacy CollateralAsset is present.
 */
export function resolveLoanCollateralAssetDisplay(
  loanSecurityType: LoanSecurityTypeEnum | undefined | null,
  collateralAsset: string | null | undefined
): string | undefined {
  if (isUnsecuredLoanSecurityType(loanSecurityType)) {
    return UNSECURED_LOAN_COLLATERAL_DISPLAY;
  }
  return collateralAsset ?? undefined;
}

/**
 * Collateral asset for booking/validation paths. Unsecured loans ignore legacy CollateralAsset.
 */
export function resolveSecuredLoanCollateralAsset(
  loanSecurityType: LoanSecurityTypeEnum | undefined | null,
  collateralAsset: string | null | undefined
): string | undefined {
  if (isUnsecuredLoanSecurityType(loanSecurityType)) {
    return undefined;
  }
  return collateralAsset ?? undefined;
}
